import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IraResultComponent } from '../ira-result/ira-result.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { Converters } from '../../static/converters';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Safe } from '../../pipes/safeHtml.pipe';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-ira-popup',
  standalone: true,
  imports: [
    IraResultComponent,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    CommonModule,
    MatTooltipModule,
    Safe,
  ],
  templateUrl: './ira-popup.component.html',
  styleUrl: './ira-popup.component.scss',
})
export class IraPopupComponent {
  dataSource = new MatTableDataSource<any>([]);
  LatestupdatesDatasource = new MatTableDataSource<any>([]);
  savedInDraft: any[] = [];
  latestUpdates: any[] = [];
  originalAllMarketingChannels: any;

  displayedColumns: string[] = [
    'statementText',
    'qualifier',
    'marketingChannel',
    'lifecycle',
    // 'pageTab',
    // 'label',
    // 'label2',
    // 'level_model',
    'manual_level',
    // 'risk',
    // 'risk_model',
    'manual_risk',
    // 'reason',
    // 'reason_model',
    'manual_reason',
  ];

  dummyData: any = [
    {
      text: 'Dummy Statement ',
      qualifier: 'Qualifier A',
      new_marketing_channel: ['Pack BOP'],
      page_no: 1,
      Label: 'Label X',
      level: '1',
      level_model: '0.7747747444',
      manual_level: { prediction: 'NA' },
      risk: '1',
      risk_model: '0.674444666',
      manual_risk: { prediction: 'NA' },
      reason: ['Nothing', 'how many'],
      reason_model: [0.77756666677],
      manual_reason: { prediction: ['NA'] },
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<IraPopupComponent>
  ) {
    // console.log('dialog data found ', this.dialogData.rows);
    // this.dataSource.data = [...this.dialogData.rows];
    // this.LatestupdatesDatasource.data = [...this.dummyData];
  }

  ngOnInit() {
    const dialogData = this.dialogRef._containerInstance._config.data;
    console.log(dialogData?.savedraftData, 'save draft dta');
    console.log(dialogData?.currentRowData, 'currentRowData dta');
    // // Assign savedraftData to savedInDraft
    // if (dialogData?.savedraftData) {
    //   this.savedInDraft = Array.isArray(dialogData.savedraftData)
    //     ? dialogData.savedraftData.map(this.mapRow)
    //     : [this.mapRow(dialogData.savedraftData)];
    // }
    // // Assign currentRowData to latestUpdates
    // if (dialogData?.currentRowData) {
    //   this.latestUpdates = [this.mapRow(dialogData.currentRowData)];
    // }
    this.savedInDraft = dialogData?.savedraftData
      ? [dialogData?.savedraftData]
      : [];
    this.latestUpdates = dialogData?.currentRowData
      ? [dialogData.currentRowData]
      : [];

    this.originalAllMarketingChannels =
      this.savedInDraft[0]?.allMarketingChannels &&
      this.savedInDraft[0].allMarketingChannels.length > 0
        ? [...this.savedInDraft[0].allMarketingChannels]
        : [];
    this.dataSource.data = this.savedInDraft;
    this.LatestupdatesDatasource.data = this.latestUpdates;
    console.log('savedInDraft', this.savedInDraft);
    console.log('latestUpdates', this.latestUpdates);
    this.latestUpdates = this.latestUpdates.map((row) => {
      return {
        ...row,
        isEdited: this.savedInDraft[0].isEdited,
        isNew: this.savedInDraft[0].isNew,
        isNewRow: this.savedInDraft[0].isNewRow,
        selected: this.savedInDraft[0].selected,
        matched_status: this.savedInDraft[0].matched_status,
        oldText: this.savedInDraft[0].oldText,
        back_translated_text: this.savedInDraft[0].back_translated_text,
        translated_text: this.savedInDraft[0].translated_text,
        translated_qualifier_text:
          this.savedInDraft[0].translated_qualifier_text,
        translation_sr_no: this.savedInDraft[0].translation_sr_no,
        richtext: this.savedInDraft[0].richtext,
      };
    });
  }

  /**to sanitize html elements */
  sanitizeHTML(content: string): SafeHtml {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.textContent || div.innerText || '';
  }

  getManualValues(value: any): string {
    return Converters.arrayChecker(value);
  }

  // Helper to map raw row data to StatementRow structure
  mapRow(row: any): any {
    // Determine if this is a savedraft row (backend keys) or current row (frontend keys)
    const isSavedraft = !!row.statement || !!row.support_strategy_rich;
    // Extract substantiations as array of objects
    let substantiationsArr: any = [];

    return {
      text: row.text || '',
      qualifiers:
        row.qualifiers ||
        row.existing_qualifier ||
        (Array.isArray(row.qualifiers) ? row.qualifiers[0] : ''),
      marketing_channel: row.marketing_channel,
      //marketing_channel: row.allMarketingChannels,
      //lifecycle: row.assessed_state,
      lifecycle: row.text_lifecycles_UI || '',
    };
  }

  closeDialog() {
    this.dialogRef.close();
  }

  // accept() {
  //   // Return dummy data to parent component and remove alert
  //   this.dialogRef.close({ ...this.dummyData[0], removeAlert: true });
  // }

  // onDeclineLatestUpdates() {
  //   // Pass savedInDraft back to parent as declined
  //   this.dataSource.data = this.savedInDraft;
  //   console.log(this.dataSource.data, 'data source after decline');
  //   console.log(
  //     'Decline clicked, returning savedInDraft:',
  //     this.savedInDraft[0]
  //   );
  //   this.dialogRef.close({
  //     action: 'decline',
  //     savedInDraft: this.savedInDraft[0],
  //   });
  // }
  onDeclineLatestUpdates() {
    // Always ensure allMarketingChannels is populated with the best available value
    const row = this.savedInDraft[0];
    // const allMarketingChannels =
    //   row.allMarketingChannels && row.allMarketingChannels.length > 0
    //     ? row.allMarketingChannels
    //     : row.marketing_channel && row.marketing_channel.length > 0
    //     ? row.marketing_channel
    //     : row.new_marketing_channel && row.new_marketing_channel.length > 0
    //     ? row.new_marketing_channel
    //     : [];
    const allMarketingChannels = this.originalAllMarketingChannels;

    const declinedRow = {
      ...row,
      allMarketingChannels,
    };
    console.log(this.originalAllMarketingChannels, 'allMarketingChannels');

    this.dataSource.data = [declinedRow];
    console.log(this.dataSource.data, 'data source after decline');
    console.log('Decline clicked, returning savedInDraft:', declinedRow);

    this.dialogRef.close({
      action: 'decline',
      savedInDraft: declinedRow,
    });
  }

  onAcceptLatestUpdates() {
    // Pass latestUpdates back to parent as accepted

    this.dialogRef.close({
      action: 'accept',
      updatedClaim: this.latestUpdates[0],
    });
  }

  // isDeclineEnabled(): boolean {
  //   const outerLifecycle = this.savedInDraft?.[0]?.assessed_state?.trim();
  //   const newLifecycle =
  //     this.savedInDraft?.[0]?.new_one?.assessed_state?.trim();

  //   const isOuterNoneOrProposed =
  //     !outerLifecycle ||
  //     outerLifecycle == 'None' ||
  //     outerLifecycle === 'Proposed';
  //   const isNewNoneOrProposed =
  //     !newLifecycle || newLifecycle == 'None' || newLifecycle === 'Proposed';

  //   // Enable if one is None/Proposed and the other is not
  //   if (isOuterNoneOrProposed !== isNewNoneOrProposed) {
  //     return true;
  //   }

  //   // Disable if both are not None/Proposed
  //   if (!isOuterNoneOrProposed && !isNewNoneOrProposed) {
  //     return false;
  //   }

  //   // Default case (both are None/Proposed)
  //   return true;
  // }

  getAssessedState(): string {
    let state = this.savedInDraft?.[0]?.assessed_state;
    if (Array.isArray(state) && state.length === 1 && state[0] === 'NA') {
      return 'None';
    }
    if (typeof state === 'string') {
      return state.trim();
    }
    return '';
  }

  isDeclineEnabled(): boolean {
    // const outerLifecycle = this.savedInDraft?.[0]?.assessed_state?.trim();
    const outerLifecycle = this.getAssessedState();
    const newLifecycle =
      this.savedInDraft?.[0]?.new_one?.assessed_state?.trim();

    // Enable if both are "Proposed"
    if (outerLifecycle === 'Proposed' && newLifecycle === 'Proposed') {
      return true;
    }

    // Enable if one is "None" and the other is "Proposed"
    if (
      (outerLifecycle === 'None' && newLifecycle === 'Proposed') ||
      (outerLifecycle === 'Proposed' && newLifecycle === 'None')
    ) {
      return true;
    }

    // Disable in all other cases
    return false;
  }
}
